var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary",class:{'summary--single': _vm.hasOnlyOneContact}},[_c('div',{staticClass:"summary__icon"},[_c(_vm.iconName,{tag:"component"})],1),_c('div',{staticClass:"summary__message"},[_c('span',{domProps:{"textContent":_vm._s(this.message)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }